var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
function SvgPhone(props) {
    return (React.createElement("svg", __assign({ viewBox: '13 14 40 52' }, props),
        React.createElement("g", { fillRule: 'evenodd', transform: 'translate(20 15)' },
            React.createElement("path", { d: 'M25.948 0c.75 0 1.357.605 1.357 1.352V48.83c0 .746-.607 1.351-1.357 1.351H1.357C.607 50.181 0 49.576 0 48.83V1.35C0 .606.607 0 1.357 0zm-2.004 2.007H3.154c-.633 0-1.147.557-1.147 1.244v43.68c0 .687.514 1.244 1.147 1.244h20.79c.634 0 1.147-.557 1.147-1.244V3.251c0-.687-.513-1.244-1.147-1.244z' }),
            React.createElement("circle", { cx: 13.55, cy: 43.66, r: 2.51 }))));
}
export default SvgPhone;
//# sourceMappingURL=Phone.js.map